import "./ScoreCardButton.css";
import config from "./appconf";
import classnames from "classnames";

interface ScoreCardButtonInfo {
  color: string;
  number: number;
  disabled: boolean;
  locked: boolean;
  marked: boolean;
  size: string;
}

function ScoreCardButton({
  color,
  number,
  disabled,
  marked,
  locked,
  size,
}: ScoreCardButtonInfo) {
  let mark = <span></span>;
  if (marked) {
    const markClasses = classnames("marked", size);
    mark = <div className={markClasses}>X</div>;
  }

  const handleClick = () => {
    fetch(`${config.baseUrl}/api/v1/markBox`, {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ color, number }),
    })
      .then((res) => {
        console.log(`Tried to mark box and got a response of ${res.status}`);
      })
      .catch((err) => {
        console.log(`Failed to POST to markBox. error=${err}`);
      });
  };

  let containerClasses = classnames(
    "scoreCardButton",
    "centerContainer",
    color,
  );

  if (size) {
    containerClasses = `${containerClasses} ${size}`;
  }

  let buttonClasses = `scoreCardButton centerContainer ${size}`;
  if (locked) {
    buttonClasses += " locked";
  } else {
    buttonClasses += ` ${color}`;
  }

  return (
    <div className={containerClasses}>
      <button
        disabled={disabled}
        className={buttonClasses}
        onClick={handleClick}
      >
        {number}
        {mark}
      </button>
    </div>
  );
}

export default ScoreCardButton;
